import React from 'react';
import {Image} from 'antd';
import './style.css';

interface TestImageProps {
    imageUrl?: string;
    maxHeight?: number;
    teacherPreview?: boolean;
}

export const TestImage: React.FC<TestImageProps> = ({
    imageUrl,
    maxHeight = 420,
    teacherPreview = false,
}) => {
    if (!imageUrl) {
        return null;
    }

    const heightCap = teacherPreview ? 240 : maxHeight;

    return (
        <div className={`image-box${teacherPreview ? ' image-box--teacher' : ''}`}>
            <Image
                src={imageUrl}
                alt=""
                className="test-question-image"
                style={{
                    maxWidth: '100%',
                    maxHeight: heightCap,
                    width: 'auto',
                    height: 'auto',
                    objectFit: 'contain',
                }}
                preview={{mask: 'Увеличить'}}
            />
        </div>
    );
};
